import { useState } from 'react'
import api from '../services/api'
import { useAuth } from '../contexts/AuthContext'

function UsernameModal({ onUsernameSet }) {
  const [username, setUsername] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { checkAuth } = useAuth()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    
    if (!username || username.length < 3 || username.length > 20) {
      setError('Username must be between 3 and 20 characters')
      return
    }
    
    if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
      setError('Username can only contain letters, numbers, underscores, and hyphens')
      return
    }
    
    setLoading(true)
    try {
      await api.post('/auth/username', { username })
      await checkAuth()
      if (onUsernameSet) {
        onUsernameSet(username)
      }
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Failed to set username'
      setError(errorMessage)
      setLoading(false)
    }
  }

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[1000] animate-modal-slide-in">
      <div className="bg-bg-darker border-2 border-border-light rounded-lg p-8 max-w-[400px] w-[90%] shadow-[0_4px_20px_rgba(0,0,0,0.5)]">
        <h2 className="mt-0 text-white text-center">Choose Your Username</h2>
        <p className="text-text-muted text-center mb-6">Select a unique username to identify yourself in the game.</p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Enter username (3-20 characters)"
            minLength={3}
            maxLength={20}
            pattern="[a-zA-Z0-9_-]+"
            disabled={loading}
            autoFocus
            className="px-3 py-3 border border-border-light rounded-sm bg-bg-panel text-white text-base focus:outline-none focus:border-accent-blue focus-visible:outline-2 focus-visible:outline-accent-blue focus-visible:outline-offset-2"
          />
          {error && <div className="text-[#ff4444] text-sm -mt-2">{error}</div>}
          <button type="submit" disabled={loading || !username} className="px-3 py-3 bg-accent-blue text-white border-none rounded-sm text-base cursor-pointer transition-colors duration-200 hover:bg-[#0056b3] disabled:bg-[#555] disabled:cursor-not-allowed focus-visible:outline-2 focus-visible:outline-accent-blue focus-visible:outline-offset-2">
            {loading ? 'Setting...' : 'Set Username'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default UsernameModal

